import Button from '../../components/Button';
import evChargerGraphic from './../../images/enphase-ev-charger.jpg';

import Slide from '../components/Slide';
import { addEVcharger } from '../data/pages';

export default function TechnicalSupport() {
  const { button, dataKey, heading } = addEVcharger;
  return (
    <>
      <Slide dataKey={dataKey} heading={heading} />
      <div
        className={`relative w-full h-[60px] sm:h-[165px] short:h-[100px] rounded-2xl my-8 overflow-hidden`}>
        <img
          alt="Enphase EV charger graphic"
          className="absolute top-0 left-0 w-full"
          src={evChargerGraphic}
        />
      </div>
      <p className="text-[16px] md:text-[18px] w-full">
        Our new bluetooth and Wi-Fi enabled chargers power customers with smart
        energy management. Charge any car with renewable energy from your
        Enphase Energy System, reduce dependence on electricity from the grid,
        or multiply savings with solar and EV charging, our chargers are
        designed to keep your EV on the road.
      </p>
      <p className="text-[16px] md:text-[18px] w-full mt-6">
        Find the perfect IQ EV Charger for your car.
      </p>
      <div className="mt-[50px] md:mt-[30px]">
        <Button
          action={() => window.location.assign(button.url)}
          className="md:w-[250px]"
          title={button.title}
          data-zuko-id="add_ev_charger_find_ev_charger"
        />
      </div>
    </>
  );
}
